/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
// ...existing code...
import { Helmet } from 'react-helmet';
import { useA11y } from '@context/Utils/A11y';

export function Meta({ title = '', description }) {
  // const [liveTitle, setLiveTitle] = useState('');
  const { tA11yTranslate, getGlobalMetaTitles } = useA11y();
  // const { globalPageTitle } = getGlobalMetaTitles();

  // useEffect(() => {
    // const timeout = setTimeout(() => {
    //   if(!title.includes('_')) {
    //     document.title = title;
    //     setLiveTitle(title);
    //   }
    // }, 500);

    // BFSG: remove after MMS testing
    // tried without timeout, but it was not working as expected
    // const firstHeadingElement = document.querySelector('h1, h2, h3, h4, h5, h6');
    // // BFSG: remove console.log
    // console.log('firstHeadingElement', firstHeadingElement);
    // if (firstHeadingElement) {
    //   // Set focus on the first heading element for better accessibility
    //   firstHeadingElement.focus({ preventScroll: true, focusVisible: false });
    // }

    // BFSG: remove after MMS testing
    // tried with timeout, but it was not working as expected
    // const firstHeadingElement = document.querySelector('h1, h2, h3, h4, h5, h6');
    // // BFSG: remove console.log
    // console.log('firstHeadingElement', firstHeadingElement);
    // const timeOutFocusedElement = setTimeout(() => {
    //   if (firstHeadingElement) {
    //     // Set focus on the first heading element for better accessibility
    //     firstHeadingElement.focus({ preventScroll: true, focusVisible: false });
    //   }
    // }, 1050);

    // const timeOutPageRead = setTimeout(() => {
    //   const mainElement = document.getElementById('activation-layout-main');
    //   if (mainElement) {
    //     mainElement.focus({ preventScroll: true, focusVisible: false });
    //   }
    // }, 1050);

    // return () => {
    //   clearTimeout(timeout);
    //   clearTimeout(timeOutPageRead);
    //   // BFSG: remove after MMS testing
    //   // clearTimeout(timeOutFocusedElement);
    // };
  // }, [title, location.pathname]);

  return (
    <>
      <Helmet>
        {/* ...existing meta tags... */}
        <meta name="description" content={tA11yTranslate("ek_global_meta_description").content} />
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover" />
        {/* Removed duplicate title and description tags */}
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
        <link rel="manifest" href="/manifest.json" />
        <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#33b6ae" />
        <meta name="msapplication-TileColor" content="#33b6ae" />
        <meta name="theme-color" content="#ffffff" />
        {/* ...existing meta tags... */}
      </Helmet>

      {/* Hidden live region for screen readers */}
      {/* {liveTitle != globalPageTitle && <div
        aria-live="polite"
        aria-atomic="true"
        style={{
          position: 'absolute',
          left: '-9999px',
          height: '1px',
          overflow: 'hidden'
        }}>
        {liveTitle} */}
      {/* </div>} */}
    </>
  );
}

export default Meta;
